module.exports = __webpack_public_path__ + "media/images/recruit/section/bumon_pc-f02608a180015490e6b96dcd9f60e10d.png";